export const COOKIE_KEY_IP_REDIR = 'redir';

export const COOKIE_VALUE_IP_REDIR_NO = 'no';
